import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Loader() {
  return (
    <>
      <section className="dots-container">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </section>
    </>
  );
}
